import type { IconEntry } from './types';

import { CUSTOM_ICON_ENTRIES } from './custom-icons';
import { MATERIAL_ICON_ENTRIES } from './material-icons';
import { MATERIAL_ICON_VIEWBOX } from './types';

/**
 * Material Symbols **Rounded** (self-hosted opsz 24) and Evisort custom SVGs.
 * `<Icon />` only reads {@link icons}.
 */

export const EDS_ICON_VIEWBOX = MATERIAL_ICON_VIEWBOX;

type IconName =
  | keyof typeof MATERIAL_ICON_ENTRIES
  | keyof typeof CUSTOM_ICON_ENTRIES;

/** Unified icon registry — the only source `<Icon />` resolves from. */
export const icons = {
  ...MATERIAL_ICON_ENTRIES,
  ...CUSTOM_ICON_ENTRIES,
} as Record<IconName, IconEntry>;

export const ICON_TYPES = (Object.keys(icons) as (keyof typeof icons)[]).sort(
  (a, b) => a.localeCompare(b),
);
